<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let displayNum = 0;

    function interpolate(start, target, durationMS) {
        if (start === target) {
            return;
        }

        const steps = target - start;
        const frameDuration = durationMS / steps;
        const newStart = start + 1;

        displayNum = newStart;

        setTimeout(() => interpolate(newStart, target, durationMS - frameDuration), frameDuration);
    }

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        tl.fromTo(drawLine, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.15,
            duration: 1,
            onStart: () => {
                interpolate(0, 57, 1000)
            },
        });

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_598" data-name="Rectangle 598" width="139.415" height="201.63" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_869" data-name="Rectangle 869" width="380" height="678"/>
    <text id="Top_three_content_essentials" data-name="Top three content essentials" transform="translate(40 51.446)"
          fill="#fcd0b1" font-size="24" font-family="Metric">
        <tspan x="0" y="0">Top three content essentials</tspan>
    </text>
    <text id="Ideas_that_are_specific_to_their_industry" data-name="Ideas that are specific to their industry"
          transform="translate(40 343)" fill="#fff" font-size="24" font-family="Metric">
        <tspan x="0" y="18">Ideas that are specific to</tspan>
        <tspan x="0" y="46">their industry</tspan>
    </text>
    <text id="_57_" data-name="57%" transform="translate(100 172)" fill="#fff" font-size="86"
          font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="27.171" y="66">{displayNum}%</tspan>
    </text>
    <g id="Group_1197" data-name="Group 1197" transform="translate(140 100)">
        <g id="Group_1196" data-name="Group 1196" clip-path="url(#clip-path)">
            <path bind:this={drawLine} id="Path_14610" data-name="Path 14610" d="M41.63,7.061A96.785,96.785,0,1,1,1,191.715" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14611" data-name="Path 14611" d="M36.386,6.6a5.4,5.4,0,1,1,5.4,5.4,5.4,5.4,0,0,1-5.4-5.4"
                  fill="#fff"/>
            <path id="Path_14612" data-name="Path 14612" d="M36.386,6.6a5.4,5.4,0,1,1,5.4,5.4A5.4,5.4,0,0,1,36.386,6.6Z"
                  fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="2.398"/>
        </g>
    </g>
</svg>
